.icon-container{
    height: 100%;
    display: flex;
    align-items: center;
}